import { render, staticRenderFns } from "./company-register.vue?vue&type=template&id=aea6e5ac&scoped=true&"
import script from "./company-register.vue?vue&type=script&lang=js&"
export * from "./company-register.vue?vue&type=script&lang=js&"
import style0 from "./company-register.vue?vue&type=style&index=0&id=aea6e5ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aea6e5ac",
  null
  
)

export default component.exports